exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TokenGetter-module__small-training___3tP5J{width:45px;height:45px;background-color:#0827e9;border-radius:7px}.TokenGetter-module__training-wrapper___3nSx4{width:175px;justify-self:center}.TokenGetter-module__training-wrapper___3nSx4.TokenGetter-module__dream-modal___2IWQg{width:225px;padding:1.25rem}", ""]);

// exports
exports.locals = {
	"small-training": "TokenGetter-module__small-training___3tP5J",
	"training-wrapper": "TokenGetter-module__training-wrapper___3nSx4",
	"dream-modal": "TokenGetter-module__dream-modal___2IWQg"
};